import React from 'react';
import { Flame } from 'lucide-react';

const CategoryTabs = ({ categories, active, gsm, onChange, onGsmChange }) => {
  return (
    <div className="border-b border-neutral-200 bg-white z-30">
      <div className="px-3 md:px-6 py-2 flex flex-wrap gap-1.5 items-center">
        {(categories || []).map((c) => {
          const isActive = active === c.slug;
          return (
            <div key={c.id} className="flex items-center gap-1">
              <button
                onClick={() => onChange(c.slug)}
                className={`text-[12px] md:text-[13px] px-2.5 py-1.5 rounded-md border transition-all font-medium ${
                  isActive
                    ? 'bg-neutral-900 text-white border-neutral-900 shadow-sm'
                    : 'bg-white text-neutral-700 border-neutral-200 hover:border-neutral-400 hover:bg-neutral-50'
                }`}
              >
                {c.hot && <Flame className="inline w-3 h-3 mr-0.5 text-orange-500" />}
                {c.label}
              </button>
              {isActive && c.has_gsm && c.gsm_options?.length > 0 && (
                <div className="flex items-center gap-0.5 ml-1 bg-neutral-100 rounded-md p-0.5">
                  <span className="text-[10px] text-neutral-500 px-1.5 italic">GSM</span>
                  {c.gsm_options.map((g) => (
                    <button
                      key={g}
                      onClick={() => onGsmChange(g)}
                      className={`text-[11px] px-1.5 py-0.5 rounded font-semibold transition-colors ${
                        gsm === g ? 'bg-orange-500 text-white' : 'text-neutral-700 hover:bg-white'
                      }`}
                    >
                      {g}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryTabs;
